import React, { useEffect, useRef } from "react";

export default function DeleteUserDialog({ user, busy, error, onCancel, onConfirm }) {
  const cancelRef = useRef(null);
  const confirmRef = useRef(null);
  useEffect(() => {
    const previousFocus = document.activeElement;
    cancelRef.current?.focus();
    return () => previousFocus?.focus();
  }, []);

  return (
    <div className="user-delete-overlay" onKeyDown={(event) => {
      if (event.key === "Escape" && !busy) onCancel();
      if (event.key === "Tab") {
        event.preventDefault();
        (document.activeElement === cancelRef.current ? confirmRef : cancelRef).current?.focus();
      }
    }}>
      <section className="user-delete-dialog" role="alertdialog" aria-modal="true"
        aria-labelledby="user-delete-title" aria-describedby="user-delete-description">
        <h2 id="user-delete-title">Delete User?</h2>
        <p id="user-delete-description">Are you sure you want to delete <strong>{user.name}</strong>?
          {" "}The user will be removed from User Management, but historical DSR, review, and approval records will be preserved.</p>
        {error && <p role="alert">{error}</p>}
        <div className="user-delete-actions">
          <button type="button" ref={cancelRef} onClick={onCancel} disabled={busy}>Cancel</button>
          <button type="button" ref={confirmRef} className="user-delete-confirm" onClick={onConfirm} disabled={busy}>
            {busy ? "Deleting..." : "Delete User"}
          </button>
        </div>
      </section>
    </div>
  );
}
